import { render } from "./App.vue?vue&type=template&id=00f94050"
const script = {}

import "./App.vue?vue&type=style&index=0&id=00f94050&lang=scss"

import exportComponent from "/home/th3g3ntl3man/github/blog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__